export const LabelAndValueHandler = (data, _key) => {
	if (data[_key]) {
		return {
			...data[_key],
			value: data[_key].id,
			label: data[_key].name
		}
	}
}
